import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingInvestor.css';

const SettingInvestor = () => {
    const [investor, setInvestor] = useState([]);
    const [filteredInvestor, setFilteredInvestor] = useState([]);
    const [search, setSearch] = useState("");
    const [editingInvestor, setEditingInvestor] = useState(null);
    const [newInvestor, setNewInvestor] = useState({
        Marca: "",
        Description: "",
        Wp: "",
        Nomenclatura: "",
        Price: "",
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchInvestor = async () => {
        const querySnapshot = await getDocs(collection(db, 'Inversores'));
        const investorsData = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setInvestor(investorsData);
        setFilteredInvestor(investorsData);
        setLoading(false);
    };
    useEffect(() => {
        fetchInvestor();
    }, []);

    useEffect(() => {
        setFilteredInvestor(
            investor.filter((investor) =>
                investor.Marca.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, investor]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewInvestor({
            ...newInvestor,
            [name]: value,
        });
    };

    const handleEditInvestor = (investor) => {
        setEditingInvestor(investor);
        setNewInvestor(investor);
    };

    const handleUpdateInvestor = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas actualizar este inversor?",
            showCancelButton: true,
            confirmButtonText: "Sí, actualizar!",
            cancelButtonText: "No, cancelar",
        });
        if (result.isConfirmed) {
            try {
                await updateDoc(doc(db, 'Inversores', editingInvestor.id), newInvestor);
                Swal.fire("Actualizado", "El inversor ha sido actualizado exitosamente.");
                setEditingInvestor(null);
                setNewInvestor({
                    Marca: "",
                    Description: "",
                    Wp: "",
                    Nomenclatura: "",
                    Price: "",
                });
                fetchInvestor();
            } catch (error) {
                console.error("Error al actualizar el inversor en la base de datos", error);
                Swal.fire("Error", "No se pudo actualizar el inversor.");
            }
        }
    };

    const handleDeleteInvestor = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás revertir esto!",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar!",
            cancelButtonText: "No, cancelar",
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, 'Inversores', id));
                Swal.fire("Borrado!", "El inversor ha sido borrado.");
                fetchInvestor();
            } catch (error) {
                console.error("Error al eliminar el inversor en la base de datos", error);
                Swal.fire("Error", "No se pudo eliminar el inversor.");
            }
        }
    };

    return (
        <div className="setting-inversor-container">
            <div className="title-actions">
                <h1 className="title">Gestión de Inversores</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar una batería" onClick={() => navigate('/admin/inversores')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por la marca del inversor"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="inversor-list">
                    {filteredInvestor.length === 0 ? (
                        <p className="no-results">El inversor que buscas no se encuentra registrado aún.</p>
                    ) : (
                        isMobile ? (
                            filteredInvestor.map(investor => (
                                <div key={investor.id} className="inversor-card">
                                    {editingInvestor && editingInvestor.id === investor.id ? (
                                        <div className="edit-form">
                                            <div className="form-group">
                                                <label htmlFor="Marca">Marca</label>
                                                <input
                                                    type="text"
                                                    name="Marca"
                                                    placeholder="Marca"
                                                    value={newInvestor.Marca}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Descripción">Descripción</label>
                                                <input
                                                    type="text"
                                                    name="Descripción"
                                                    placeholder="Descripción"
                                                    value={newInvestor.Description}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Wp">Wp</label>
                                                <input
                                                    type="text"
                                                    name="Wp"
                                                    placeholder="Wp"
                                                    value={newInvestor.Wp}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Nomenclatura">Nomenclatura</label>
                                                <input
                                                    type="text"
                                                    name="Nomenclatura"
                                                    placeholder="Nomenclatura"
                                                    value={newInvestor.Nomenclatura}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Precio">Precio</label>
                                                <input
                                                    type="text"
                                                    name="Precio"
                                                    placeholder="Precio"
                                                    value={newInvestor.Price}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="btn-form-actions">
                                                <button className="btn-ac" title="Guardar" onClick={handleUpdateInvestor}><FontAwesomeIcon icon={faAdd} /></button>
                                                <button className="btn-de" title="Cancelar" onClick={() => setEditingInvestor(null)}><FontAwesomeIcon icon={faBan} /></button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="inversor-info">
                                                <h3>{investor.Marca}</h3>
                                                    <p><strong>Descripción:</strong> {investor.Description}</p>
                                                <p><strong>Wp:</strong> {investor.Wp}</p>
                                                <p><strong>Nomenclatura:</strong> {investor.Nomenclatura}</p>
                                                <p><strong>Precio:</strong> {investor.Price}</p>
                                            </div>
                                            <div className="btn-actions">
                                                <button className="btn-ed" title="Actualizar" onClick={() => handleEditInvestor(investor)}><FontAwesomeIcon icon={faRotate} /></button>
                                                <button className="btn-de" title="Eliminar" onClick={() => handleDeleteInvestor(investor.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="inversor-list">
                                <div className="inversor-header">
                                    <span>Marca</span>
                                    <span>Descripción</span>
                                    <span>Wp</span>
                                    <span>Nomenclatura</span>
                                    <span>Precio</span>
                                    <span>Acciones</span>
                                </div>
                                <ul>
                                    {filteredInvestor.map(investor => (
                                        <li key={investor.id}>
                                            {editingInvestor && editingInvestor.id === investor.id ? (
                                                <div className="edit-form">
                                                    <input
                                                        type="text"
                                                        name="Marca"
                                                        placeholder="Marca"
                                                        value={newInvestor.Marca}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Descripción"
                                                        placeholder="Descripción"
                                                        value={newInvestor.Description}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Wp"
                                                        placeholder="Wp"
                                                        value={newInvestor.Wp}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Nomenclatura"
                                                        placeholder="Nomenclatura"
                                                        value={newInvestor.Nomenclatura}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Precio"
                                                        placeholder="Precio"
                                                        value={newInvestor.Price}
                                                        onChange={handleInputChange}
                                                    />
                                                    <div className="btn-actions">
                                                        <button className="btn-ac" title="Guardar" onClick={handleUpdateInvestor}> <FontAwesomeIcon icon={faAdd} /></button>
                                                        <button className="btn-de" title="Cancelar" onClick={() => setEditingInvestor(null)}><FontAwesomeIcon icon={faBan} /></button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span>{investor.Marca}</span>
                                                        <span>{investor.Description}</span>
                                                    <span>{investor.Wp}</span>
                                                    <span>{investor.Nomenclatura}</span>
                                                    <span>{investor.Price}</span>
                                                    <button className="btn-ed" title="Actualizar" onClick={() => handleEditInvestor(investor)}> <FontAwesomeIcon icon={faRotate} /></button>
                                                    <button className="btn-de" title="Eliminar" onClick={() => handleDeleteInvestor(investor.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );

}

export default SettingInvestor;